// function recalcSlick(selector) {
//   if (window.jQuery && jQuery(selector).hasClass('slick-initialized')) {
//     jQuery(selector).slick('setPosition');
//   } else {
//     alert();
//   }
// }

// // Example: after window resize
// window.addEventListener('resize', function() {
//   recalcSlick('.product-gallery__main_slider');
// });

// window.addEventListener('load', function() {
//   recalcSlick('.product-gallery__main_slider');
// });

// document.addEventListener('shopify:section:load', function() {
//   recalcSlick('.product-gallery__main_slider');
// });

// document.addEventListener('shopify:section:reorder', function() {
//   recalcSlick('.product-gallery__main_slider');
// });
// document.addEventListener('DOMContentLoaded', function () {
//     const customSizeBtn = document.querySelector(".custom-select-size-button");
//     const optionsDropdown = document.querySelector(".footbar-product__options");
//     const atcBtn = document.querySelector(".footbar-product__button-add-to-cart button[name='add']");

//     if (customSizeBtn && optionsDropdown && atcBtn) {
//         customSizeBtn.addEventListener('click', function () {
//             optionsDropdown.classList.toggle('show');
//             atcBtn.classList.remove('show');
//         });

//         optionsDropdown.querySelector('select').addEventListener('change', function () {
//             customSizeBtn.querySelector('span').innerText = 'Size: ' + this.options[this.selectedIndex].text;
//             optionsDropdown.classList.remove('show');
//             atcBtn.classList.add('show');
//         });
//     }


document.addEventListener('click', function (e) {
    const target = e.target.closest(
        '.popup-quick-view__content .product-options [data-section-container]:first-child .product-options__section .product-options__value'
    );

    if (target) {
        const styleAttr = target.getAttribute('style');

        if (styleAttr) {
            const match = styleAttr.match(/--custom-option-image:\s*url\((['"]?)(.*?)\1\);?/);

            if (match && match[2]) {
                const imageUrl = match[2];
                console.log('Extracted Image URL:', imageUrl);

                const img = document.querySelector(
                '.popup-quick-view__content .product-gallery__sheet > .row .product-gallery__sheet_item:first-child img'
                );

                if (img) {
                    img.src = imageUrl;
                    img.removeAttribute('srcset');
                    img.removeAttribute('data-srcset');
                    img.removeAttribute('data-master');
                    img.removeAttribute('data-ll-status');
                    img.removeAttribute('loading');
                    img.removeAttribute('onload');
                    img.classList.remove('lazyload', 'loaded', 'entered', 'preloaded');
                    img.style.display = 'block';
                    img.style.opacity = '1';
                }
            }
        }
    }
});


// function appendRelatedProduct() {
//     const body = document.body;
//     const sectionClass = "complete-the-look";
//     const section = document.getElementsByClassName(sectionClass)[0];
//     const tabsElement = document.querySelector(".product-page .product-page__tabs");

//     if (
//         body.classList.contains("template-product") &&
//         tabsElement &&
//         section &&
//         localStorage.getItem("show_related_products_inside_product_info")
//     ) {
//         const carousel = section.querySelector("carousel-products");
//         if (carousel) {
//             carousel.classList.add("inside-product-info");
//         }

//         // Move the section after the tabs
//         tabsElement.parentNode.insertBefore(section, tabsElement.nextSibling);

//         section.querySelectorAll('.product-collection__image').forEach(image => {
//             const anchor = image.querySelector('a');
//             if (anchor) anchor.removeAttribute('data-js-product-image');
//         });

//         // Wait for DOM to update before triggering layout refresh
//         requestAnimationFrame(() => {
//             const slickElem = section.querySelector("[data-js-carousel-slick]");
//             if (slickElem && typeof jQuery !== "undefined" && typeof jQuery(slickElem).slick === "function") {
//                 setTimeout(function(){
//                     jQuery(slickElem).slick("setPosition");
//                 }, 500)
//             }
//         });
//     }
// }

// appendRelatedProduct();


// });



jQuery(document).ready(function($) {
  $('[data-style="colour"] .product-options__value').on('click', function() {
    setTimeout(function(){
      $('.product-gallery__thumbnail .product-gallery__thumbnail_item:visible').eq(1).trigger('click');
      $('.product-gallery__thumbnail .product-gallery__thumbnail_item:visible').eq(0).trigger('click');
    }, 500);
  });
});
